export enum BadgesApiList {
  GetBadges = '/api/v1/badges',
  ClearBadges = '/api/v1/badges/clear',
}
